import { Collapse, Popconfirm, Tag, Select } from 'antd';
import Loader from 'components/loader';
import usePublications from "hooks/usePublications";
import useRequests from "hooks/useRequests";
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { storePublication } from 'services/Publications';
import { estadoPublicacion, routesNames } from "utils/Constants";
import { jornadas, states, tipoContratacion, turnos } from "utils/Tables";
import { formatDateFull, getNameFromObject } from "utils/Utils";
import PostulatedsTable from './components/PostulatedsTable';
import ModalGraphicResources from './components/ModalGraphicResources';
import { getAllEspecialidades } from 'services/Especialidades';
import { setChangeStatus, getEstadosPublicaciones } from 'services/Estados';
import { InstagramOutlined } from "@ant-design/icons";
import { SITE_URL } from "config/config"

const PUBLIC_URI = process.env.REACT_APP_PUBLIC_URI_IMAGES;

export default function Publication() {
    // let navigate = useNavigate()
    const { isLoading, response, fetchData } = usePublications()
    const { changeStatus } = useRequests()
    const [especialidades, setEspecialidades] = useState([])
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [type, setType] = useState(null)
    const [estadoPub, setEstadoPub] = useState(response?.estado_id || null)
    const [estados, setEstados] = useState([])

    let { id } = useParams();


    useEffect(() => {
        fetchData(id)
        getEspecialidades()
        getEstados()
    }, [])

    useEffect(() => {
        setEstadoPub(response?.estado_id)
        // console.log(response)
    }, [response])


    const getEspecialidades = async () => {
        const data = await getAllEspecialidades()

        // console.log(data)
        setEspecialidades(data)
    }

    if (isLoading) {
        return (
            <div className="mt-10 flex items-center justify-center">
                <Loader />
            </div>
        )
    }

    const getEstados = async () => {
        const data = await getEstadosPublicaciones()
        const estados = data.map(item => ({
            value: item.id,
            label: item.nombre
        }));

        setEstados(estados)
    }

    // const changeStatusPublication = async (id, payload) => {

    //     const bodyPayload = {
    //         ...payload,
    //         type: 'P'
    //     }

    //     await changeStatus(id, bodyPayload)
    //     window.location.reload()
    //     // navigate(routesNames.REQUESTS)
    // }

    const resources = [
        {
            value: 'feed',
            label: <p className='font-semibold'><InstagramOutlined className='mr-2' /> IG Feed (1080 x 1350px)</p>,
        },
        // {
        //     value: 'post',
        //     label: <p className='font-semibold'><InstagramOutlined className='mr-2' /> IG Post (1080 x 1080px)</p>,
        // },
        {
            value: 'story',
            label: <p className='font-semibold'><InstagramOutlined className='mr-2' /> IG Story (1080 x 1920px)</p>,
        },
    ]

    const handleSelect = (value) => {
        setEstadoPub(value)
    }

    const handleSelectType = (value) => {
        setIsModalOpen(true)
        setType(value)

    }

    if (!isLoading && response) {
        return (
            <div className="mt-3 flex items-start flex-col min-h-screen gap-2">
                <div className='flex items-start justify-between gap-2 w-full'>
                    <div className='border rounded-lg w-full h-full p-4 bg-white'>
                        <div className=' border flex items-center justify-between gap-3 px-4 w-full py-3 rounded-lg'>
                            <div className='w-[80px] sm:w-[50%]'>
                                <img className="object-contain w-[100px] h-full z-0 mb-2" src={`${PUBLIC_URI}uploads/${response?.cuenta?.logo_url}`} />
                            </div>

                            <div className='flex lg:flex-col flex-col gap-1 items-start'>
                                <span className='text-xl sm:text-xl font-bold mb-2'>{response?.cuenta?.nombre}</span>
                                {response?.cuenta?.slogan && <span className='text-gray-500 text-xs text-start'>{response?.cuenta?.slogan}</span>}
                                {response?.cuenta?.resena && <span className='font-semibold text-md' >{response?.cuenta?.resena}</span>}
                            </div>

                            <div className='flex  flex-col gap-1 items-center'>
                                {response.cuenta?.user?.plan?.detalle?.id == 1 ? <span className='text-sm font-bold border border-main text-black px-3 py-1 mt-2 rounded-lg text-center'>GOLD</span> : <span className='text-sm font-bold border border-purple-500 text-black px-3 py-1 mt-2 rounded-lg text-center'>STANDARD</span>}
                                {response?.privada == 1 && <span className='text-sm font-bold bg-main text-black px-3 py-1 mt-2 rounded-lg text-center'>PUBLICACIÓN CONFIDENCIAL</span>}
                            </div>
                        </div>

                        <div className='mt-4'>
                            <div className='flex sm:flex-row flex-col w-full gap-3 items-start'>
                                <div className='flex flex-col gap-3 w-full items-start'>
                                    <Link className='text-blue-600 text-sm' to={`${routesNames.PUBLICATION_EDIT}/${id}`}>Editar publicación</Link>
                                    <a href={SITE_URL + `publication/${response?.slug}`} target="_blank" className='text-blue-600 text-sm'>Ver publicación</a>

                                    <span className='my-2 text-xl font-bold'>{response?.nombre}</span>

                                    <div className='flex flex-col items-start'>
                                        <span className='text-md font-semibold mb-2 border-b block w-full'>Descripción general</span>
                                        <span id="publication-body" className="whitespace-pre-line text-sm text-start mt-1" dangerouslySetInnerHTML={{ __html: response.descripcion }}></span>
                                    </div>

                                    <div className='flex flex-col items-start gap-2 w-full mt-4'>
                                        <span className='text-md font-semibold mb-2 border-b block w-full'>Contratación y jornada</span>
                                        {/* <span className="text-sm text-start font-semibold">Tipo de contratación: <span className='font-normal'>{getNameFromObject(tipoContratacion, response.tipo_contratacion)}</span></span> */}
                                        <span className="text-sm text-start font-semibold">Turno: <span className='font-normal'>{getNameFromObject(turnos, response.turno)}</span></span>
                                        <span className="text-sm text-start font-semibold">Tipo de jornada: <span className='font-normal'>{getNameFromObject(jornadas, response.jornada)}</span></span>

                                        {
                                            response.especialidad_id === null ?
                                                <span className="text-sm text-start font-semibold">Especialidad: <span className='font-normal'>Sin especialidad</span></span>
                                                :
                                                <span className="text-sm text-start font-semibold">Especialidad: <span className='font-normal'>{getNameFromObject(especialidades, response.especialidad_id, 'especialidad', true)}</span></span>

                                        }

                                        <span className='text-md font-semibold mb-1 mt-4 border-b block w-full'>Ubicación</span>
                                        <span className="text-sm text-start font-semibold">Provincia: <span className='font-normal'> {getNameFromObject(states, response.ubicacion?.provincia)}</span></span>
                                        <span className="text-sm text-start font-semibold">Localidad: <span className='font-normal'>{response.ubicacion?.localidad}</span></span>
                                        {/* <span className="text-sm text-gray-500 text-start font-semibold">Zona: <span className='font-normal'>Norte GBA</span></span> */}
                                    </div>
                                </div>

                            </div>
                        </div>


                    </div>

                    <section className='w-full h-full max-w-[500px] flex flex-col gap-y-2'>

                        <div className='border rounded-lg w-full h-full max-w-[500px] p-4 bg-white flex flex-col items-start'>
                            <Tag color={`${response?.estado_publicacion?.color}`}>{response?.estado_publicacion?.nombre}</Tag>

                            <div className='mt-4 flex flex-col gap-2 text-sm'>

                                <div className='flex flex-col gap-2'>

                                    {response?.facturacion_sin_finalizar?.pago_confirmado === 1 && <span className='font-semibold text-base'>Estado</span>}

                                    {response?.facturacion_sin_finalizar?.pago_confirmado === 1 && response.estado_id === estadoPublicacion.NO_APROBADA && <Tag color='red' className='text-center'>Publicación rechazada</Tag>}

                                    <div className='flex flex-col text-sm'>
                                        <Select
                                            className='w-full'
                                            placeholder='Estado de publicación'
                                            value={estadoPub}
                                            onSelect={handleSelect}
                                            options={estados}
                                        />

                                        <Popconfirm
                                            title="Cambiar estado"
                                            description="¿Está seguro que desea cambiar el estado de la publicación?"
                                            onConfirm={async () => {
                                                await setChangeStatus(response.id, { estado: estadoPub })
                                                window.location.reload()
                                            }}
                                            className='mt-2'
                                            okText="Si"
                                            cancelText="No"
                                            okButtonProps={
                                                { className: "bg-blue-500" }
                                            }
                                        >
                                            <button className='rounded-md px-4 py-1 text-sm bg-main text-black'>Cambiar estado</button>
                                        </Popconfirm>
                                    </div>

                                    <div className='flex flex-col text-sm mt-5'>
                                        <span className='text-lg font-semibold'>Generar Placas</span>

                                        <Select
                                            className='w-full'
                                            placeholder='Tipo de recurso gráfico...'
                                            value={type}
                                            onSelect={handleSelectType}
                                            options={resources}
                                        />

                                        <ModalGraphicResources
                                            isModalOpen={isModalOpen}
                                            setIsModalOpen={setIsModalOpen}
                                            data={response}
                                            type={type}
                                            setType={setType}
                                        />
                                    </div>

                                    <div className='mt-5'>
                                        <span className='text-lg mt-5 mb-3 font-semibold'>Info de contacto</span>
                                        {/* <span>Datos solicitante: {response.cuenta?.user?.email}</span> */}
                                        {/* <span className='font-semibold'>Responsable:</span> */}
                                        <div className='flex flex-col gap-0 mb-2'>
                                            <span className=''>Cuenta: {response.cuenta?.nombre}</span>
                                            <span className=''>Fecha: {formatDateFull(response?.created_at)}</span>
                                        </div>

                                        <span className='font-semibold'>Responsable:</span>
                                        <div className='flex flex-col gap-0'>
                                            {/* <span className=''>Nombre: {response.cuenta?.responsable_nombre}</span> */}
                                            {/* <span className=''>Email: {response.cuenta?.responsable_email}</span> */}
                                            <span className=''>Teléfono: {response.cuenta?.responsable_telefono}</span>
                                            {/* <span className=''>DNI: {response.cuenta?.responsable_documento}</span> */}
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>

                    </section>

                </div>
                <div className=' mt-5 w-full mb-3'>
                    <Collapse
                        items={[{
                            key: '1',
                            label: 'Postulaciones',
                            children: <PostulatedsTable id={id} />
                        }]}
                    // defaultActiveKey={['1']} 
                    />
                </div>
            </div >
        )
    }
}
